// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node) => {
  const { desktopFilter, desktopFilterModal, desktopFilterModalOverlay } = choozy(node);
  const observer = new IntersectionObserver((entries) => {
    if (entries[0]?.target === desktopFilter)
      desktopFilterModal[entries[0].isIntersecting ? 'removeAttribute' : 'setAttribute'](
        'open',
        '',
      );
  });

  observer.observe(desktopFilter);
  desktopFilterModalOverlay[
    desktopFilterModal.scrollWidth < 896 ? 'setAttribute' : 'removeAttribute'
  ]('hidden', '');
});
